import { render, staticRenderFns } from "./newtokenmodal.vue?vue&type=template&id=ead35adc&"
import script from "./newtokenmodal.vue?vue&type=script&lang=js&"
export * from "./newtokenmodal.vue?vue&type=script&lang=js&"
import style0 from "./newtokenmodal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports